module.exports = __webpack_public_path__ + "img/ranch-mushroom-appetizer.6c874d77.jpg";